import { BaseConfig } from '../internals/config';
/**
 *  Order configuration class
 *
 * @todo
 */
export class OrderConfig extends BaseConfig {
    constructor(config) {
        super(config);
    }
}
//# sourceMappingURL=config.js.map